import React from "react";
import { Link, useNavigate } from "react-router-dom";

/**
 * Public shell for the new agentic pages. No auth, no sign-out — just nav.
 * Keeps the AidWaive branding consistent without touching the existing public site.
 */
export default function AppShell({ children }) {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-white">
      <header className="nav-frost sticky top-0 z-40">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
          <div className="flex items-center gap-7">
            <Link to="/" className="flex items-center gap-2" data-testid="appshell-logo">
              <img
                src="/aidwaive-logo.png"
                alt="AidWaive"
                className="h-10 sm:h-11 w-auto object-contain select-none"
                draggable={false}
              />
            </Link>
            <nav className="hidden md:flex items-center gap-5 text-sm">
              <Link to="/app" data-testid="nav-app-home" className="text-slate-600 hover:text-[#0f172a]">Overview</Link>
              <Link to="/app/saver" data-testid="nav-saver" className="text-slate-600 hover:text-[#0f172a]">Money Saver</Link>
              <Link to="/app/dream-school" data-testid="nav-dream" className="text-slate-600 hover:text-[#0f172a]">Dream School</Link>
              <Link to="/app/calendar" data-testid="nav-calendar" className="text-slate-600 hover:text-[#0f172a]">Calendar</Link>
              <Link to="/app/fafsa" data-testid="nav-fafsa" className="text-slate-600 hover:text-[#0f172a]">FAFSA</Link>
            </nav>
          </div>
          <button
            onClick={() => navigate("/")}
            data-testid="appshell-back-home"
            className="text-xs text-slate-500 hover:text-[#0f172a] underline-offset-4 hover:underline"
          >
            ← back to AidWaive home
          </button>
        </div>
      </header>
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">{children}</main>
    </div>
  );
}
